module.exports = __webpack_public_path__ + "img/ic-playlists-active.d7c7cf2d.svg";